module.exports = __webpack_public_path__ + "img/Schedule Icon.b109c33d.svg";